<div class="m-tree"
     :class="{ 'm-tree__multiple-node-checkbox' : isMultipleSelectWithCheckboxes, 'm-tree__file-icons' : useFilesIcons }">
    <m-message class="m-tree__error"
               v-if="errorTree"
               state="warning"
               skin="light"
               ref="error-tree-txt">
        {{'m-tree:error' | f-m-i18n}}
    </m-message>
    <p class="m-tree__empty"
       v-if="propTreeEmpty"
       ref="empty-tree-txt">
        {{'m-tree:empty' | f-m-i18n}}
    </p>
    <ul class="m-tree__content"
        v-else>
        <m-tree-node ref="tree-node"
                     v-for="node in tree"
                     :class="{'m--is-single': isSingleNodeTree }"
                     :key="node.id"
                     :selectable="selectable"
                     :open.sync="node.open"
                     :node="node"
                     :selected-nodes="propSelectedNodes"
                     :disabled-nodes="disabledNodes"
                     :readonly="isReadonly"
                     :checkboxes="checkboxes"
                     :use-files-icons="useFilesIcons"
                     @click="onClick"></m-tree-node>
    </ul>
</div>
